import script from "./ToastOverlayHistorical.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastOverlayHistorical.vue?vue&type=script&setup=true&lang=js"

import "./ToastOverlayHistorical.vue?vue&type=style&index=0&id=233116ee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233116ee"]])

export default __exports__